import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconAssignment = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.88 1.99935H12.6667C13.4 1.99935 14 2.59935 14 3.33268V12.666C14 13.3993 13.4 13.9993 12.6667 13.9993H3.33333C2.6 13.9993 2 13.3993 2 12.666V3.33268C2 2.59935 2.6 1.99935 3.33333 1.99935H6.12C6.4 1.22602 7.13333 0.666016 8 0.666016C8.86667 0.666016 9.6 1.22602 9.88 1.99935ZM8.66667 2.66602C8.66667 2.29935 8.36667 1.99935 8 1.99935C7.63333 1.99935 7.33333 2.29935 7.33333 2.66602C7.33333 3.03268 7.63333 3.33268 8 3.33268C8.36667 3.33268 8.66667 3.03268 8.66667 2.66602ZM7.33268 11.9987H8.66602V5.33203H7.33268V11.9987ZM4.66602 11.9987H5.99935V7.33203H4.66602V11.9987ZM11.3327 11.9987H9.99935V8.66536H11.3327V11.9987Z",
		fill: "#333333"
	})
});
export default SvgIconAssignment;
